<template>
  <div class="form-group row">
    <label
      for="inputText"
      class="col-sm-2 col-form-label"
      >{{label}}</label>
    <div class="col-sm-10">
      <input
        v-model="text"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        type="text"
        id="inputText"
        />
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      required: true
    },
    readonly: Boolean,
    label: String,
    placeholder: String
  },
  computed: {
    text: {
      get () {
        return this.value
      },
      set (value) {
        this.v.$touch()
        this.$emit('input', value)
      }
    }
  }
}
</script>
